export const conditioningTablesDisableFalse = [
  {
    label: "Filtración",
    id: 5,
    value: "filtration",
    disabled: false,
  },
  {
    label: "Congelación",
    id: 1,
    value: "freezing",
    disabled: false,
  },
  {
    label: "Refrigeración",
    id: 2,
    value: "refrigeration",
    disabled: false,
  },
  {
    label: "Acidificación",
    id: 3,
    value: "acidification",
    disabled: false,
  },
  {
    label: "No Aplica",
    id: 4,
    value: "not_applicable",
  },
];

export const conditioningTablesDisableTrue = [
  {
    label: "Filtración",
    id: 5,
    value: "filtration",
    disabled: true,
  },
  {
    label: "Congelación",
    id: 1,
    value: "freezing",
    disabled: true,
  },
  {
    label: "Refrigeración",
    id: 2,
    value: "refrigeration",
    disabled: true,
  },
  {
    label: "Acidificación",
    id: 3,
    value: "acidification",
    disabled: true,
  },
  {
    label: "No Aplica",
    id: 4,
    value: "not_applicable",
  },
];

export const mapNameToValue: any = {
  filtration: "Filtración",
  freezing: "Congelación",
  refrigeration: "Refrigeración",
  acidification: "Acidificación",
  not_applicable: "No Aplica",
};
